import React from 'react'

// JSON floats like 9.0 / -1.0 parse to plain numbers in JS, so they already render as
// "9" / "-1"; only null needs handling.
const fmt = (value) => (value == null ? '-' : value)

// Compact speed / glide / turn / fade badges. Works for both the user's discs and the
// brand catalog molds (both expose s/g/t/f).
function FlightNumbers({ disc = {} }) {
  const numbers = [
    { label: 'S', value: disc.s },
    { label: 'G', value: disc.g },
    { label: 'T', value: disc.t },
    { label: 'F', value: disc.f },
  ]

  const hasAny = numbers.some((n) => n.value != null)
  if (!hasAny) return <span className="flight-numbers flight-numbers--empty">—</span>

  return (
    <span className="flight-numbers">
      {numbers.map((n) => (
        <span key={n.label} className="flight-numbers--cell" title={n.label}>
          {fmt(n.value)}
        </span>
      ))}
    </span>
  )
}

export default FlightNumbers
